<template>
  <div>
    <toastification-loading-content ref="loadingToast" />
    <toastification-progress-content ref="progressToast" />

    <sidenav
      :is-sidebar-active.sync="isSidebarActive"
      :item-edit.sync="itemEdit"
      :is-add.sync="isAdd"
      @refetch-data="refetchData"
      :panel-model-options="panelModelOptions"
    />
    <b-row class="pt-2 pb-1">
      <b-col cols="6">
        <BreadcrumbMenu />
      </b-col>
    </b-row>

    <!-- <filter-modal @action="buildFilters()" @clear="clearSearchFilters()">
      <template v-slot:main-filters>
        <filters
          :search-query.sync="searchQuery"
          :facilities="facilitiesOptions"
          :facilities-filter.sync="facilitiesFilter"
          :centers="centerOptions"
          :center-filter.sync="centerFilter"
          :sectors="sectorOptions"
          :sector-filter.sync="sectorFilter"
        />
      </template>
    </filter-modal> -->

    <!-- Table Container Card -->
    <b-card class="mx-2" no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="text-capitalize">{{ $t("table.show") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label class="text-capitalize">{{ $t("table.entries") }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('table.search')"
              />
              <b-button
                variant="primary"
                @click="openAdd()"
                v-if="$can('create', 'Intelbras')"
              >
                <span class="text-nowrap text-capitalize">{{
                  `${$t("actions.add")} ${$tc("intelbras.profile", 1)}`
                }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        show-empty
        :empty-text="$t('no_record_found')"
      >
        <template #head()="data">
          <span> {{ $tc(data.label, 1) }}</span>
        </template>

       <!--  <template #head(name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #cell(unit.description)="data">
          {{ unitsSite(data.item) }}
        </template>

        <template #head(center.name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(sector.name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template> -->

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            :id="`actions-${data.item.id}`"
            tabindex="0"
            variant="white"
            class="px-1 btn-y"
          >
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </b-button>
          <b-popover
            :target="`actions-${data.item.id}`"
            triggers="focus"
            placement="bottom"
            custom-class="popover-p-0"
            variant="white"
          >
            <b-list-group class="m-0">
              <b-list-group-item
                v-if="$can('update', 'Intelbras')"
                class="border-0"
                :to="{ name: 'intelbras_profiles_rules', params: { id_intelbras_profile: data.item.id } }"
              >
                <feather-icon icon="BellIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  Alarms
                </span>
              </b-list-group-item>

              <b-list-group-item
                v-if="$can('update', 'Intelbras')"
                class="border-0"
                button
                @click="openEdit(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("actions.edit") }}
                </span>
              </b-list-group-item>

              <b-list-group-item
                v-if="$can('update', 'Intelbras')"
                class="border-0"
                button
                @click="confirmDelete(data.item.id)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("actions.delete") }}
                </span>
              </b-list-group-item>
            </b-list-group>
          </b-popover>
        </template>
      </b-table>
      <!-- Footer Table -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">{{
              $t("table.showing", {
                from: dataMeta.from,
                to: dataMeta.to,
                of: dataMeta.of,
              })
            }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="update"
              :perPage="perPage"
            >
            </Pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BInputGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, onMounted } from "@vue/composition-api";
import useList from "./useList";
import Sidenav from "./Sidenav.vue";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ToastificationLoadingContent from '@core/components/toastification/ToastificationLoadingContent.vue';
import ToastificationProgressContent from '@core/components/toastification/ToastificationProgressContent.vue';
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";
import Filters from "./Filters.vue";

export default {
  components: {
    Sidenav,
    Pagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    vSelect,
    ToastificationLoadingContent,
    ToastificationProgressContent,
    BreadcrumbMenu,
    FilterModal,
    ButtonFilters,
    Filters,
  },

  setup(_, context) {
    //start pagination
    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const loadingToast = ref(null);
    const isSidebarActive = ref(false);
    const itemEdit = ref({});
    const isAdd = ref(false);

    const openEdit = (item) => {
      isSidebarActive.value = true;
      itemEdit.value = JSON.parse(JSON.stringify(item));
      isAdd.value = false;
    };
    const { t } = useI18nUtils();

    const toast = useToast();

    const trans = {
      "messages.delete.title": t("messages.delete.title"),
      "messages.delete.body": t("messages.delete.body"),
      "actions.delete": t("actions.delete"),
      "actions.cancel": t("actions.cancel"),
      "intelbras.actions": t("intelbras.actions"),
      "intelbras.syncCorrectly": t("intelbras.syncCorrectly"),
      "intelbras.events": t("intelbras.events"),
      "intelbras.status": t("intelbras.status"),
    };

    const {
      // methods
      fetchList,
      refetchData,
      //clearSearchFilters,
      //buildFilters,

      //table pagination
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,

      // filters
     /*  centerFilter,
      sectorFilter,
      facilitiesFilter, */

      // Options
     /*  facilitiesOptions,
      centerOptions,
      sectorOptions, */

      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      panelModelOptions,
      //filtersCount,
    } = useList();

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: trans["messages.delete.title"],
        text: trans["messages.delete.body"],
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: trans["actions.delete"],
        cancelButtonText: trans["actions.cancel"],
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
            .dispatch("intelbras_rules/delete", id)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.message,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                self.refetchData();
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: response.message,
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const openAdd = () => {
      isAdd.value = true;
      isSidebarActive.value = true;
    };

    const copyToClipboard = (id, field) => {
      store
        .dispatch("intelbras_panels/copyPassword", { id, field })
        .then((response) => {
          navigator.clipboard.writeText(response.data.value);
          toast({
            component: ToastificationContent,
            props: {
              title: "Copiado correctamente",
              icon: "ClipboardIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            props: {
              title: "No se pudo copiar",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const onError = () => {
      toast({
        component: ToastificationContent,
        props: {
          title: "No se pudo copiar",
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    };

    const unitsSite = (item) => {
      let { units } = item.device;

      if (units.length) {
        let unitsDescription = units.map((unit) => unit.description);

        return unitsDescription.join(",");
      }

      return "";
    };

    return {
      isSidebarActive,
      isAdd,
      itemEdit,
      openEdit,
      openAdd,
      confirmDelete,
      update,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,

      panelModelOptions,

     /*  centerFilter,
      sectorFilter,
      facilitiesOptions, */
     /*  centerOptions,
      sectorOptions,
      facilitiesFilter, */

      onError,

      //filtersCount,
      //buildFilters,
      //clearSearchFilters,
      unitsSite
    };
  },
};
</script>
